// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Secure CV
 * Service Secure CV
 * Version: v.0.1.0
 */
/**
 * Prediction that a person in the image created via deepfake (or not).
 *
 * | deepfake | value |
 * |--------------|---|
 * | fake         | 0 |
 * | real         | 1 |
 */
export type DeepfakeState = typeof DeepfakeState[keyof typeof DeepfakeState];


export const DeepfakeState = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
